import './App.css';
import BookingRoom from './BookingRoom/BookingRoom.js'
import {ConfigProvider} from 'antd'

import locale from 'antd/locale/es_ES';

import 'dayjs/locale/es';

function App() {
  return (
  	<ConfigProvider
	  theme={{
		  components: {
			Modal: {
			  contentBg: 'linear-gradient(180deg, rgba(0, 34, 39, 0.50) 0%, rgba(36, 36, 36, 0.50) 100%);',
			},
		  },
	  }}
	  locale={locale}
	>
      <BookingRoom />
  	</ConfigProvider>
  );
}

export default App;
